import Vue from 'vue'
import App from './App'
import store from './store'
import vuetify from './plugins/vuetify'
import router from './router'
import apolloProvider from './graph/apollo'
import { isLoggedIn, getUserId } from './auth'

// Vue Plugins
import bugsnag from '@bugsnag/js'
import bugsnagVue from '@bugsnag/plugin-vue'
import smartlook from 'smartlook-client'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import VueMoment from 'vue-moment'
import VueOffline from 'vue-offline'
import Meta from 'vue-meta'
import LoadScript from 'vue-plugin-load-script'
import VueGtm from 'vue-gtm'
import VueAmplitude from 'vue-amplitude'
// import VueObserveVisibility from 'vue-observe-visibility'
// import VueMultianalytics from 'vue-multianalytics'

import { defineCustomElements } from '@ionic/pwa-elements/loader'
import { Plugins } from '@capacitor/core'

const { SplashScreen } = Plugins

// Polyfills
import './polyfills'

// Filters
import './filters'

// Service worker registration
import './registerServiceWorker'

Vue.config.performance = false // performance tracing in the browser devtool
Vue.config.productionTip = false // prevent the production tip on Vue startup

const {
  VUE_APP_BUGSNAG_API_KEY,
  VUE_APP_SMARTLOOK_API_KEY,
  VUE_APP_AMPLITUDE_API_KEY
} = process.env

// Bug tracking
const bugsnagClient = bugsnag(VUE_APP_BUGSNAG_API_KEY)
bugsnagClient.use(bugsnagVue, Vue)

// Utils
Vue.use(VueLodash, { lodash })
Vue.use(VueMoment)
Vue.use(VueOffline)

Vue.use(Meta)

// Plugin for injecting remote scripts
Vue.use(LoadScript)

// Detect when an element is becoming visible or hidden on the page
// Vue.use(VueObserveVisibility)

// Wrapper for Intercom (customer messaging platform)
// Vue.use(VueIntercom, { appId: 'intercom_app_id' })

smartlook.init(VUE_APP_SMARTLOOK_API_KEY)
Vue.prototype.$smartlook = smartlook

// Google Tag Manager
Vue.use(VueGtm, {
  id: 'GTM-W7ZHGHJ',
  vueRouter: router
})

// Wrapper for Amplitude (events tracking & analytics)
Vue.use(VueAmplitude, { apiKey: VUE_APP_AMPLITUDE_API_KEY })
// TODO: fix
Vue.prototype.$amplitude.logEvent = (...args) =>
  Vue.prototype.$amplitude.getInstance().logEvent(...args)

// Track any event in multiple platforms
// Vue.use(VueMultianalytics, {
//   modules: {
//     segment: { token: 'segment_access_token' }
//   },
//   routing: {
//     vueRouter: router,
//     preferredProperty: 'name'
//   }
// })

const options = {
  store,
  vuetify,
  router,
  apolloProvider,
  render: h => {
    // Hide the splash
    SplashScreen.hide()
    return h(App)
  },
  data: () => ({
    loggedIn: isLoggedIn(),
    userId: getUserId()
  })
}

/* eslint-disable no-new */
new Vue(options).$mount('#app')

// PWA Elements are required for some Capacitor plugins to work.
defineCustomElements(window)
